import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enCommon from './locales/en/common.json'
import ptBRCommon from './locales/pt-BR/common.json'

/**
 * i18n initialization for Markfy.
 *
 * Detection order:
 *   1. Explicit user override stored in localStorage (`markfy.locale`)
 *   2. localStorage fallback handled by the detector
 *   3. `navigator.language` (this is what makes pt-BR the default for
 *      Brazilian browsers without any user action)
 *   4. Hard fallback to `en`
 *
 * Namespaces are split by feature; Phase 0 ships only `common` to prove the
 * pipeline. New namespaces are added per-feature under
 * `i18n/locales/{en,pt-BR}/<namespace>.json` and registered here.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      'pt-BR': { common: ptBRCommon },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt-BR'],
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'markfy.locale',
      caches: ['localStorage'],
    },
  })

export default i18n
